<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <h5 class="title">Abseilgeräte</h5>
      </div>
      <!--<SelectLocation v-if="role > 2" @locationChanged="updateLocation"></SelectLocation>-->
      <div class="col-md-4 text-right">
        <p-button type="default" @click="openStats" class="mt-0 mr-1"><i class="bi bi-bar-chart-line"></i> Auswertung</p-button>
        <p-button type="default" @click="showRescues = true" class="mt-0 mr-1"><i class="bi bi-tree"></i> Alle Rettungen</p-button>
        <p-button v-if="role >= 3" type="default" @click="openManageHubs" class="mt-0 mr-2" title="Abseilgeräte verwalten"><i class="bi bi-tools"></i></p-button>
      </div>
    </div>
    <div class="card-body row">
      <div class="col">
            <div class="row mt-0">
              <div
                class="col-md-6"
                v-for="hub in hubs"
                :key="hub.name"
              >
                <div class="card mt-3">
                  <div class="card-body">
                    <h5 class="card-title">{{ hub.name }} <i class="bi bi-exclamation-triangle-fill" style="color: orange;" title="Wartung fällig" v-if="(hub.deviceType == 'hub' && (hub.metersDown >= 500 || hub.metersUp >= 4)) || (hub.deviceType == 'safedescent' && hub.metersDown >= 7600 && hub.rescueAktivCount == 0) || (hub.deviceType == 'safedescent' && hub.metersDown >= 750 && hub.rescueAktivCount > 0)"></i><i class="bi bi-exclamation-octagon-fill" style="color: red;" title="Außer Betrieb" v-if="hub.outOfService == true"></i></h5>
                    <h6 class="card-subtitle mb-2 text-muted" style="color: red!important; font-weight: bolder!important;" v-if="hub.outOfService == true">Außer Betrieb</h6>
                    <i>
                      <b>Passiv-Rettungen:</b> {{ hub.rescueCount }}<br>
                      <b>Aktiv-Rettungen:</b> {{ hub.rescueAktivCount }}<br>
                      <b>Abseilmeter:</b> {{ hub.metersDown }} m <br>
                      <b>Hubmeter:</b> {{ hub.metersUp.toFixed(2).replace(".", ",") }} m
                    </i>
                  </div>
                  <div class="card-footer">
                    <div class="row">
                      <div class="col-9">
                        <p-button type="success" @click="newRescue(hub.key, hub.name)" :disabled="hub.outOfService == true" size="default" title="Rettung eintragen" block
                      ><i class="bi bi-file-plus"></i> Rettung eintragen</p-button
                    >
                      </div>
                      <div class="col-2 ml-0 pl-0">
                      <p-button type="warning" @click="showMaintenance(hub.key, hub.name, hub.metersUp, hub.metersDown, hub.rescueCount, hub.rescueAktivCount)" size="default" title="Wartungen"
                          ><i class="bi bi-gear"></i>
                          </p-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </div>

    <modal
      :show.sync="showNewForm"
      headerClasses="justify-content-center"
    >
      <h5 slot="header" class="title mb-0">Rettung eintragen ({{ newRescueHubDeviceName }})</h5>
      <label class="pt-1">Parcours</label>
      <el-select
        placeholder="Parcours"
        v-model="newRescueParcours"
        filterable
        @change="updateHeight($event)">
        <el-option v-for="parc in parcours"
          :value=parc.parcoursName
          :label=parc.parcoursName
          :key=parc.parcoursName>
        </el-option>
      </el-select>
      <template v-if="currentParcoursElements.length > 0">
        <label class="pt-4">Element/Plattform</label>
        <el-select
          placeholder="Element/Plattform wählen"
          v-model="newRescueElement"
          filterable>
          <el-option v-for="el in currentParcoursElements"
            :value="el.elementName"
            :label="el.elementName + (el.elementType ? ' (' + el.elementType + ')' : '')"
            :key="el.key">
          </el-option>
        </el-select>
      </template>
      <label class="pt-4 mb-0">Abseilmeter (m)</label>
      <el-slider v-model="newRescueHeightDown" show-input :min="1" :max="50" class="ml-2"></el-slider>
      <label class="pt-4 mb-0">Hubmeter (m)</label>
      <el-slider v-model="newRescueHeightUp" show-input :min="0" :max="1" :step="0.1" class="ml-2"></el-slider>
      <label class="pt-2">Mitarbeiter</label>
      <el-select
        placeholder="Mitarbeiter"
        v-model="newRescueTrainer">
        <el-option v-for="trainer in trainers"
          :value=trainer.trainerName
          :label=trainer.trainerName
          :key=trainer.trainerName>
        </el-option>
      </el-select>
      <fieldset>
        <div class="form-group">
          <label class="pt-4 control-label">Anmerkungen zur Rettung <small class="text-muted">(optional)</small></label>
          <div class="">
            <textarea
              class="form-control"
              placeholder="Anmerkungen zur Rettung (Element, Besonderheiten)"
              rows="2"
              v-model="newRescueAnmerkung"
            ></textarea>
          </div>
        </div>
        <el-checkbox v-model="newRescueScrew" label="Rolle wurde wieder mit 17 Nm verschlossen" class="pt-2" v-if="location == 'NB'" required size="merdium"><span style="color: red"><b>Rolle wurde wieder mit 17 Nm verschlossen</b></span></el-checkbox>
        <el-checkbox v-model="newRescueTraining" label="Übung" class="pt-2">Übung</el-checkbox>
        <el-checkbox v-model="newRescueAktivrettung" label="Aktivrettung (doppelte Personenlast)" class="pt-2">Aktivrettung <small class="text-muted">(doppelte Personenlast)</small></el-checkbox>
      </fieldset>
      
      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showNewForm = false;"
            >Abbrechen</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="addRescue" :disabled="(location == 'NB' && newRescueScrew == false) || saveInProgress == true || (currentParcoursElements.length > 0 && !newRescueElement)"
            >Speichern</p-button
          >
        </div>
      </template>
    </modal>

    <modal
      :show.sync="showRescues"
      headerClasses="justify-content-center"
      class="rescueModal"
      modalMaxWidth="90%"
    >
      <h5 slot="header" class="title mb-0">Alle Rettungen</h5>
      <el-table
            :data="rescues"
            header-row-class-name="text-primary"
            empty-text="Es konnten keine Rettungen gefunden werden."
          >
          <el-table-column prop="rescueDateTime" label="Datum"> </el-table-column>
          <el-table-column prop="rescueParcours" label="Parcours" sortable> </el-table-column>
          <el-table-column prop="rescueElement" label="Element" sortable> </el-table-column>
          <el-table-column prop="rescueDown" label="Abseilmeter" sortable> </el-table-column>
          <el-table-column prop="rescueUp" label="Hubmeter" sortable> </el-table-column>
          <el-table-column prop="rescueHub" label="Abseilgerät" sortable> </el-table-column>
          <el-table-column prop="rescueTrainer" label="Mitarbeiter" sortable> </el-table-column>
          <el-table-column prop="rescueMode" label="Art" sortable> </el-table-column>
          <el-table-column prop="rescueNote" label="">
            <template slot-scope="scope">
                <div v-if="scope.row.rescueNote">
                  <el-tooltip
                    :content="
                      scope.row.rescueNote
                    "
                    placement="top"
                  >
                    <i
                      class="bi bi-info-circle"
                      style="font-size: 1.2rem; color: green"
                    ></i>
                  </el-tooltip>
                </div>
            </template>
          </el-table-column>

      </el-table>
    </modal>

    <modal
      :show.sync="showStatsForm"
      headerClasses="justify-content-center"
      class="rescueModal"
      modalMaxWidth="70%"
    >
      <h5 slot="header" class="title mb-0">Auswertung: Rettungen je Element/Parcours</h5>
      <div class="stats-filter">
        <el-date-picker
          v-model="statsDateRange"
          type="daterange"
          range-separator="bis"
          start-placeholder="Von"
          end-placeholder="Bis"
          format="dd.MM.yyyy"
          :clearable="false"
          :picker-options="statsPickerOptions"
          @change="updateStatsDateRange"
        ></el-date-picker>
        <div class="stats-presets">
          <p-button size="sm" :type="statsPeriod === 'all' ? 'primary' : 'default'" @click="setStatsPeriod('all')">Gesamter Zeitraum</p-button>
          <p-button size="sm" :type="statsPeriod === 'thisMonth' ? 'primary' : 'default'" @click="setStatsPeriod('thisMonth')">Dieser Monat</p-button>
          <p-button size="sm" :type="statsPeriod === 'lastMonth' ? 'primary' : 'default'" @click="setStatsPeriod('lastMonth')">Letzter Monat</p-button>
          <p-button size="sm" :type="statsPeriod === 'thisYear' ? 'primary' : 'default'" @click="setStatsPeriod('thisYear')">Dieses Jahr</p-button>
          <p-button size="sm" :type="statsPeriod === 'lastYear' ? 'primary' : 'default'" @click="setStatsPeriod('lastYear')">Letztes Jahr</p-button>
        </div>
      </div>
      <div v-if="statsLoading" class="text-muted text-center py-4">Lade Daten...</div>
      <div v-else-if="statsData.length === 0" class="text-muted text-center py-4">Es konnten keine Rettungen gefunden werden.</div>
      <div v-else class="stats-list">
        <div class="stats-row" v-for="(item, index) in statsData" :key="item.label">
          <div class="stats-rank">{{ index + 1 }}.</div>
          <div class="stats-info">
            <div class="stats-label">{{ item.label }}</div>
            <div class="stats-bar-bg">
              <div class="stats-bar-fill" :style="{ width: item.percent + '%' }"></div>
            </div>
          </div>
          <div class="stats-count">{{ item.count }}</div>
        </div>
      </div>
      <template slot="footer">
        <div class="right-side">
          <p-button type="default" link @click="showStatsForm = false">Schließen</p-button>
        </div>
      </template>
    </modal>

    <modal
      :show.sync="showMaintenanceForm"
      headerClasses="justify-content-center"
      class="rescueModal"
      modalMaxWidth="95%"
    >
      <h5 slot="header" class="title mb-0">Wartungen {{ newMaintenanceHubName }}</h5>
        <h5>Neue Wartung erfassen</h5>
        <label class="pt-2">Wartung durchgeführt von</label>
        <el-select
          placeholder="Mitarbeiter"
          v-model="newMaintenanceTrainer"
          filterable>
          <el-option v-for="trainer in allTrainers"
            :value=trainer.trainerName
            :label=trainer.trainerName
            :key=trainer.trainerName>
          </el-option>
        </el-select>
        <fieldset>
        <div class="form-group">
          <label class="pt-4 control-label">Anmerkungen zur Wartung</label>
          <div class="">
            <textarea
              class="form-control"
              placeholder="Durchgeführte Arbeiten, getauschte Komponenten, Mängel..."
              rows="2"
              v-model="newMaintenanceAnmerkung"
            ></textarea>
          </div>
        </div>       
      </fieldset>
      <el-checkbox v-model="newMaintenanceOutOfService" label="Abseilgerät ist NICHT betriebsbereit" class="pt-2"><b>Abseilgerät ist NICHT betriebsbereit</b></el-checkbox>
      <div class="text-right pb-4" >
        <p-button type="success" @click="addMaintenance()" :disabled="saveInProgress == true"><i class="bi bi-file-plus"></i> Wartung speichern</p-button>
      </div>
        
        <h5>Bisherige Wartungen</h5>
        <el-table
            :data="maintenance"
            header-row-class-name="text-primary"
            empty-text="Es konnten keine Wartungen gefunden werden."
            show-summary
            sum-text="Gesamt"
            :summary-method="getSum"
            table-layout="auto"
          >
          <el-table-column prop="date" label="Datum" min-width="35"> </el-table-column>
          <el-table-column prop="metersDown" label="Abseilmeter" min-width="40">
            <template slot-scope="scope">
              {{ scope.row.metersDown.toFixed(0).replace(".", ",") + ' m' }}
            </template>
          </el-table-column>
          <el-table-column prop="metersUp" label="Hubmeter" min-width="40">
            <template slot-scope="scope">
              {{ scope.row.metersUp.toFixed(2).replace(".", ",") + ' m' }}
            </template>
          </el-table-column>
          <el-table-column prop="rescueCount" label="Passiv-Rettungen" min-width="40"> </el-table-column>
          <el-table-column prop="rescueAktivCount" label="Aktiv-Rettungen" min-width="40"> </el-table-column>
          <el-table-column prop="trainer" label="Mitarbeiter" min-width="40"> </el-table-column>
          <el-table-column prop="description" label="Anmerkungen" min-width="100"> </el-table-column>
      </el-table>
    </modal>

    <modal
      :show.sync="showManageForm"
      headerClasses="justify-content-center"
      class="rescueModal"
      modalMaxWidth="90%"
    >
      <h5 slot="header" class="title mb-0">Abseilgeräte verwalten</h5>
      <h5>Neues Abseilgerät anlegen</h5>
      <div class="row">
        <div class="col-md-12">
          <label class="pt-2">Name</label>
          <el-input v-model="newHubName" placeholder="Name des Abseilgerätes"></el-input>

        </div>
      </div>
      <div class="text-right pb-4 pt-3">
        <p-button type="success" @click="addHub" :disabled="saveInProgress == true || !newHubName.trim()"><i class="bi bi-file-plus"></i> Abseilgerät anlegen</p-button>
      </div>

      <h5>Vorhandene Abseilgeräte</h5>
      <el-table
        :data="manageHubs"
        header-row-class-name="text-primary"
        empty-text="Es konnten keine Abseilgeräte gefunden werden."
        table-layout="auto"
      >
        <el-table-column prop="name" label="Name" min-width="120">
          <template slot-scope="scope">
            <input
              v-if="editingHubKey === scope.row.key"
              type="text"
              class="form-control"
              v-model="editingHubName"
            />
            <span v-else>
              {{ scope.row.name }}
              <i v-if="scope.row.hidden" class="bi bi-eye-slash text-muted" title="Ausgeblendet"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Status" min-width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.hidden" style="color: #999;">Ausgeblendet</span>
            <span v-else style="color: green;">Sichtbar</span>
          </template>
        </el-table-column>
        <el-table-column label="" min-width="140">
          <template slot-scope="scope">
            <template v-if="editingHubKey === scope.row.key">
              <p-button type="success" size="sm" @click="saveEditHub" :disabled="saveInProgress == true || !editingHubName.trim()" title="Speichern" class="mr-1"><i class="bi bi-check-lg"></i></p-button>
              <p-button type="default" size="sm" @click="cancelEditHub" title="Abbrechen"><i class="bi bi-x-lg"></i></p-button>
            </template>
            <template v-else>
              <p-button type="info" size="sm" @click="startEditHub(scope.row)" title="Namen ändern" class="mr-1"><i class="bi bi-pencil"></i></p-button>
              <p-button :type="scope.row.hidden ? 'success' : 'danger'" size="sm" @click="toggleHubHidden(scope.row)" :title="scope.row.hidden ? 'Einblenden' : 'Ausblenden'">
                <i :class="scope.row.hidden ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </p-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <template slot="footer">
        <div class="right-side">
          <p-button type="default" link @click="showManageForm = false">Schließen</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { Tabs, TabPane, Modal } from "src/components/UIComponents";
import { Loading, MessageBox, Select, Option, Slider, Checkbox, Input, DatePicker } from "element-ui";
import router from "../../../../main";
import store from "../../../../store";
import { db, fc, FirebaseStorage } from "../../../../firebaseDb";
import { FieldValue } from 'firebase/firestore';
import firebase from 'firebase/compat/app'
import moment from "moment-timezone";
import SelectLocation from '/src/components/KET/Views/Components/KETSelectLocation.vue'
Vue.use(Loading);
Vue.use(Checkbox);
Vue.use(DatePicker);

export default {
  components: {
    MessageBox,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Slider.name]: Slider,
    SelectLocation,
    [Input.name]: Input,
  },

  data() {
    return {
      hubs: [],
      trainers: [],
      allTrainers: [],
      parcours: [],
      rescues: [],
      maintenance: [],
      loading: true,
      location: store.getters.userlocation,
      role: store.getters.userrole,
      showNewForm: false,
      newRescueDateTime: null,
      newRescueParcours: null,
      newRescueElement: null,
      newRescueHubDeviceName: null,
      newRescueHubDeviceKey: null,
      newRescueHeightDown: 0,
      newRescueHeightUp: 0,
      newRescueTrainer: null,
      newRescueAnmerkung: "",
      newRescueTraining: false,
      newRescueScrew: false,
      newRescueAktivrettung: false,
      newMaintenanceAnmerkung: "",
      newMaintenanceTrainer: "",
      newMaintenanceHub: "",
      newMaintenanceHubName: "",
      newMaintenanceMetersUp: 0,
      newMaintenanceMetersDown: 0,
      newMaintenanceRescueCount: 0,
      newMaintenanceOutOfService: false,
      showRescues: false,
      showMaintenanceForm: false,
      saveInProgress: false,
      showManageForm: false,
      manageHubs: [],
      newHubName: "",
      newHubDeviceType: "hub",
      editingHubKey: null,
      editingHubName: "",
      showStatsForm: false,
      statsData: [],
      statsLoading: false,
      statsDateRange: null,
      statsPeriod: 'all',
      statsPickerOptions: {
        disabledDate(time) {
          return time.getTime() > moment().endOf("day").valueOf();
        },
        firstDayOfWeek: 1,
      },
    };
  },
  created() {
    this.loadData();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadData();
      }
    );
  },
  computed: {
    currentParcoursElements() {
      const parc = this.parcours.find((p) => p.parcoursName === this.newRescueParcours);
      return parc ? parc.elements : [];
    },
  },
  methods: {
    loadData() {
      const hubsRef = db.collection("hubs");
      hubsRef.where('locationID', '==', this.location).orderBy("name").onSnapshot((snapshotChange) => {
        this.hubs = [];
        this.manageHubs = [];
        snapshotChange.forEach((doc) => {
            const data = doc.data();
            const entry = {
              key: doc.id,
              name: data.name,
              metersDown: data.metersDown,
              metersUp: data.metersUp,
              rescueCount: data.rescueCount,
              rescueAktivCount: data.rescueAktivCount || 0,
              deviceType: data.deviceType,
              outOfService: data.outOfService || false,
              hidden: data.hidden || false
            };
            this.manageHubs.push(entry);
            if (!entry.hidden) {
              this.hubs.push(entry);
            }
        });
        this.loading = false
      });

      const parcoursRef = db.collection("parcours");
      parcoursRef.where('locationID', '==', this.location).orderBy("position").onSnapshot((snapshotChange) => {
        this.parcours = [];
        snapshotChange.forEach((doc) => {
          const parcEntry = {
            key: doc.id,
            parcoursName: doc.data().Name,
            parcoursPosition: doc.data().position,
            parcoursHeight: doc.data().height || 0,
            elements: [],
          };
          this.parcours.push(parcEntry);
          parcoursRef.doc(doc.id).collection("elements").orderBy("elementPosition").get().then((elementsSnapshot) => {
            const elements = [];
            elementsSnapshot.forEach((elementDoc) => {
              elements.push({
                key: elementDoc.id,
                elementName: elementDoc.data().elementName,
                elementPosition: elementDoc.data().elementPosition,
                elementType: elementDoc.data().elementType,
              });
            });
            parcEntry.elements = elements;
          });
        });
      });

      const rescuesRef = db.collection("rescues");
      rescuesRef.where('locationID', '==', this.location).orderBy("DateTime", "desc").limit(100).onSnapshot((snapshotChange) => {
        this.rescues = [];
        snapshotChange.forEach((doc) => {
          var note = ""
          if(doc.data().Training) {
            note = 'Übung ' + doc.data().Note
          } else {
            note = doc.data().Note
          }

          var mode = ""
          if (doc.data().Aktivrettung == true) {
            mode = "Aktiv"
          } else {
            mode = "Passiv"
          }

          this.rescues.push({
            key: doc.id,
            rescueParcours: doc.data().Parcours,
            rescueElement: doc.data().Element || '-',
            rescueDateTime: moment(new Date(doc.data().DateTime.seconds * 1000))
                .format("DD.MM.yyyy, HH:mm")
                .toString() + " Uhr",
            rescueDown: doc.data().Down + ' m',
            rescueUp: doc.data().Up.toFixed(2).replace(".", ",") + ' m',
            rescueNote: note,
            rescueTrainer: doc.data().Trainer,
            rescueHub: doc.data().Hub,
            rescueMode: mode
          });
        });
      });

      const trainerRef = db.collection('trainer')
      trainerRef.where('locationID', 'array-contains', this.location).where('isToday', '==', true).where('isTodayLocation', '==', this.location).orderBy('Name').onSnapshot((snapshotChange) => {
      this.trainers = []
      snapshotChange.forEach((doc) => {
        this.trainers.push({
          trainerName: doc.data().Name
        })
      })
    })
    trainerRef.where('locationID', 'array-contains', this.location).orderBy('Name').onSnapshot((snapshotChange) => {
      this.allTrainers = []
      snapshotChange.forEach((doc) => {
        this.allTrainers.push({
          trainerName: doc.data().Name
        })
      })
    })
    this.loading = false
    },
    updateHeight(parcours) {
      const height = this.parcours.find(p => p.parcoursName === parcours).parcoursHeight
      if(height) {
        this.newRescueHeightDown = height
      }
      this.newRescueElement = null
    },
    newRescue(key, name) {
      this.newRescueDateTime = new Date(),
      this.newRescueParcours = null,
      this.newRescueElement = null,
      this.newRescueHubDeviceName = name,
      this.newRescueHubDeviceKey = key,
      this.newRescueHeightDown = 0,
      this.newRescueHeightUp = 0,
      this.newRescueTrainer = null,
      this.newRescueTraining = false,
      this.newRescueAnmerkung = "",
      this.newRescueScrew = false,
      this.newRescueAktivrettung = false,
      this.showNewForm = true;
    },
    addRescue() {
      const elementRequired = this.currentParcoursElements.length > 0
      if(this.newRescueParcours && this.newRescueHeightDown && this.newRescueTrainer && this.newRescueHubDeviceName && (this.location == 'DA' || this.newRescueScrew == true) && (!elementRequired || this.newRescueElement)) {
        this.saveInProgress = true
        var batch = db.batch()
        const hubsRef = db.collection('hubs')
        const rescuesRef = db.collection('rescues')

        const rescueId = rescuesRef.doc().id;
        batch.set(rescuesRef.doc(rescueId), {
          DateTime: this.newRescueDateTime,
          Parcours: this.newRescueParcours,
          Element: this.newRescueElement || null,
          Hub: this.newRescueHubDeviceName,
          HubId: this.newRescueHubDeviceKey,
          Down: this.newRescueHeightDown,
          Up: this.newRescueHeightUp,
          Trainer: this.newRescueTrainer,
          Training: this.newRescueTraining,
          Note: this.newRescueAnmerkung,
          Screw: this.newRescueScrew,
          Aktivrettung: this.newRescueAktivrettung,
          locationID: this.location,
        })

        if (this.newRescueAktivrettung == true) {
          batch.update(hubsRef.doc(this.newRescueHubDeviceKey), {
            rescueAktivCount: firebase.firestore.FieldValue.increment(1),
            metersDown: firebase.firestore.FieldValue.increment(this.newRescueHeightDown),
            metersUp: firebase.firestore.FieldValue.increment(this.newRescueHeightUp)
          })
        } else {
          batch.update(hubsRef.doc(this.newRescueHubDeviceKey), {
            rescueCount: firebase.firestore.FieldValue.increment(1),
            metersDown: firebase.firestore.FieldValue.increment(this.newRescueHeightDown),
            metersUp: firebase.firestore.FieldValue.increment(this.newRescueHeightUp)
          })
        }

        batch.commit().then(() => {
          this.newRescueDateTime = null,
          this.newRescueParcours = null,
          this.newRescueElement = null,
          this.newRescueHubDeviceName = null,
          this.newRescueHubDeviceKey = null,
          this.newRescueHeightDown = 0,
          this.newRescueHeightUp = 0,
          this.newRescueTrainer = null,
          this.newRescueAnmerkung = ""
          this.newRescueTraining = false,
          this.newRescueScrew = false,
          this.newRescueAktivrettung = false,
          this.showNewForm = false;
          this.saveInProgress = false;
          this.$notify({
            message: 'Rettung wurde erfolgreich gespeichert!',
            icon: 'fa fa-check-circle',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success',
            showClose: true,
            timeout: 5000
          })
        })
      }
    },

    showMaintenance(key, name, up, down, count, aktivcount) {
      this.newMaintenanceHub = key
      this.newMaintenanceHubName = name
      this.newMaintenanceMetersUp = up
      this.newMaintenanceMetersDown = down
      this.newMaintenanceRescueCount = count
      this.newMaintenanceRescueAktivCount = aktivcount
      this.newMaintenanceTrainer = ""
      this.newMaintenanceAnmerkung = ""
      const hubsRef = db.collection("hubs");
      hubsRef.doc(key).collection("maintenance").orderBy("date", "desc").onSnapshot((snapshotChange) => {
        this.maintenance = [];
        snapshotChange.forEach((doc) => {
            this.maintenance.push({
              key: doc.id,
              trainer: doc.data().trainer,
              metersDown: doc.data().metersDown,
              metersUp: doc.data().metersUp,
              rescueCount: doc.data().rescueCount,
              rescueAktivCount: doc.data().rescueAktivCount,
              deviceType: doc.data().deviceType,
              date: moment(new Date(doc.data().date.seconds * 1000))
                .format("DD.MM.yyyy")
                .toString(),
              description: doc.data().description,
            });
        });
        this.showMaintenanceForm = true
        this.saveInProgress = false
      });
    },
    addMaintenance() {
      if(this.newMaintenanceTrainer != "" && this.newMaintenanceAnmerkung != "") {
      this.saveInProgress = true
      db.collection("hubs").doc(this.newMaintenanceHub).collection("maintenance").add({
        date: new Date(),
        trainer: this.newMaintenanceTrainer,
        description: this.newMaintenanceAnmerkung,
        metersDown: this.newMaintenanceMetersDown,
        metersUp: this.newMaintenanceMetersUp,
        rescueCount: this.newMaintenanceRescueCount,
        rescueAktivCount: this.newMaintenanceRescueAktivCount
      }).then(() => {
        db.collection("hubs")
                .doc(this.newMaintenanceHub)
                .update({
                  metersDown: 0,
                  metersUp: 0,
                  rescueCount: 0,
                  rescueAktivCount: 0,
                  outOfService: this.newMaintenanceOutOfService,
                  lastReset: new Date()
                }).then(() => {
                  this.newMaintenanceHub = ""
                  this.newMaintenanceHubName = ""
                  this.newMaintenanceMetersUp = 0
                  this.newMaintenanceMetersDown = 0
                  this.newMaintenanceRescueCount = 0
                  this.newMaintenanceRescueAktivCount = 0
                  this.newMaintenanceAnmerkung = "",
                  this.newMaintenanceTrainer = ""
                  this.newMaintenanceOutOfService = false
                  this.saveInProgress = false
                  this.showMaintenanceForm = false
                }).catch((error) => {
                  console.error("Error updating hub: ", error);
                  this.saveInProgress = false
                });
      }).catch((error) => {
        console.error("Error adding maintenance: ", error);
        this.saveInProgress = false
      });
    }
    },
    getSum(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Gesamt";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));
        if (index === 1) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values
              .reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
              .toFixed(0)
              .replace(".", ",")
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ' m';
          } else {
            sums[index] = "N/A";
          }
        } else if (index === 2) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values
              .reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
              .toFixed(2)
              .replace(".", ",")
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ' m';
          } else {
            sums[index] = "N/A";
          }
        } else if (index === 3 || index === 4) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values
              .reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
              .toFixed(0)
              .replace(".", ",")
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
          } else {
            sums[index] = "N/A";
          }
        }
      });

      return sums;
    },

    updateLocation(loc) {
      this.location = loc
      this.loadData()
    },
    openStats() {
      this.showStatsForm = true
      this.loadStats()
    },
    updateStatsDateRange() {
      this.statsPeriod = 'custom'
      this.loadStats()
    },
    setStatsPeriod(period) {
      const today = moment().startOf("day")
      this.statsPeriod = period
      if (period === 'all') {
        this.statsDateRange = null
      } else if (period === 'thisMonth') {
        this.statsDateRange = [moment().startOf("month").toDate(), today.toDate()]
      } else if (period === 'lastMonth') {
        this.statsDateRange = [moment().subtract(1, "month").startOf("month").toDate(), moment().subtract(1, "month").endOf("month").toDate()]
      } else if (period === 'thisYear') {
        this.statsDateRange = [moment().startOf("year").toDate(), today.toDate()]
      } else if (period === 'lastYear') {
        this.statsDateRange = [moment().subtract(1, "year").startOf("year").toDate(), moment().subtract(1, "year").endOf("year").toDate()]
      }
      this.loadStats()
    },
    loadStats() {
      this.statsLoading = true
      const rescuesRef = db.collection("rescues")
      const hasDateRange = this.statsDateRange && this.statsDateRange.length === 2
      const rangeEnd = hasDateRange ? moment.min(moment(this.statsDateRange[1]).endOf("day"), moment().endOf("day")).toDate() : moment().endOf("day").toDate()
      let query = rescuesRef.where('locationID', '==', this.location).where('DateTime', '<=', rangeEnd).orderBy("DateTime", "desc")
      if (hasDateRange) {
        query = query.where('DateTime', '>=', moment(this.statsDateRange[0]).startOf("day").toDate())
      }
      query.get().then((snapshotChange) => {
        const counts = {}
        snapshotChange.forEach((doc) => {
          const data = doc.data()
          const parcoursName = data.Parcours || 'Unbekannt'
          const elementName = data.Element
          const label = elementName ? (parcoursName + ' – ' + elementName) : (parcoursName + ' (ohne Element)')
          counts[label] = (counts[label] || 0) + 1
        })
        const arr = Object.keys(counts).map((label) => ({ label, count: counts[label] }))
        arr.sort((a, b) => b.count - a.count)
        const max = arr.length > 0 ? arr[0].count : 1
        this.statsData = arr.map((item) => ({
          ...item,
          percent: Math.round((item.count / max) * 100),
        }))
        this.statsLoading = false
      }).catch((error) => {
        console.error("Error loading stats: ", error)
        this.statsLoading = false
      })
    },
    openManageHubs() {
      this.newHubName = ""
      this.newHubDeviceType = "hub"
      this.editingHubKey = null
      this.editingHubName = ""
      this.showManageForm = true
    },
    startEditHub(hub) {
      this.editingHubKey = hub.key
      this.editingHubName = hub.name
    },
    cancelEditHub() {
      this.editingHubKey = null
      this.editingHubName = ""
    },
    saveEditHub() {
      if (!this.editingHubKey || !this.editingHubName.trim()) return
      this.saveInProgress = true
      db.collection("hubs").doc(this.editingHubKey).update({
        name: this.editingHubName.trim()
      }).then(() => {
        this.editingHubKey = null
        this.editingHubName = ""
        this.saveInProgress = false
        this.$notify({
          message: 'Name wurde aktualisiert!',
          icon: 'fa fa-check-circle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success',
          showClose: true,
          timeout: 4000
        })
      }).catch((error) => {
        console.error("Error updating hub name: ", error)
        this.saveInProgress = false
      })
    },
    toggleHubHidden(hub) {
      const newHidden = !hub.hidden
      MessageBox.confirm(
        newHidden
          ? 'Soll dieses Abseilgerät wirklich ausgeblendet werden?'
          : 'Soll dieses Abseilgerät wieder eingeblendet werden?',
        'Bestätigung',
        {
          confirmButtonText: 'Ja',
          cancelButtonText: 'Abbrechen',
          type: 'warning'
        }
      ).then(() => {
        this.saveInProgress = true
        db.collection("hubs").doc(hub.key).update({
          hidden: newHidden
        }).then(() => {
          this.saveInProgress = false
          this.$notify({
            message: newHidden ? 'Abseilgerät wurde ausgeblendet.' : 'Abseilgerät wurde eingeblendet.',
            icon: 'fa fa-check-circle',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success',
            showClose: true,
            timeout: 4000
          })
        }).catch((error) => {
          console.error("Error toggling hub hidden: ", error)
          this.saveInProgress = false
        })
      }).catch(() => {})
    },
    addHub() {
      if (!this.newHubName.trim()) return
      this.saveInProgress = true
      db.collection("hubs").add({
        name: this.newHubName.trim(),
        deviceType: "safedescent",
        locationID: this.location,
        metersDown: 0,
        metersUp: 0,
        rescueCount: 0,
        rescueAktivCount: 0,
        outOfService: false,
        hidden: false,
        createdAt: new Date()
      }).then(() => {
        this.newHubName = ""
        this.saveInProgress = false
        this.$notify({
          message: 'Abseilgerät wurde angelegt!',
          icon: 'fa fa-check-circle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success',
          showClose: true,
          timeout: 4000
        })
      }).catch((error) => {
        console.error("Error adding hub: ", error)
        this.saveInProgress = false
      })
    }
  },
};
</script>
<style scoped>
.stats-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}
.stats-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.stats-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 60vh;
  overflow-y: auto;
  padding: 4px 2px;
}
.stats-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.stats-rank {
  width: 28px;
  text-align: right;
  font-weight: bold;
  color: #888;
  flex-shrink: 0;
}
.stats-info {
  flex: 1;
  min-width: 0;
}
.stats-label {
  font-size: 0.9rem;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stats-bar-bg {
  background: #eee;
  border-radius: 6px;
  height: 14px;
  overflow: hidden;
}
.stats-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #66bb6a, #2e7d32);
  border-radius: 6px;
  transition: width 0.4s ease;
}
.stats-count {
  width: 40px;
  text-align: right;
  font-weight: bold;
  color: #333;
  flex-shrink: 0;
}
</style>
